var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHlTeachers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.235 2.08334V5.41668",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9017 3.75H14.5684",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3392 9.58334H13.0059",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.83334H9.16663",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08337 14.5833V12.0833",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08337 14.5833V12.0833",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08337 14.5833H7.08337",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58337 19.5833V16.25",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58337 7.5V11.6667",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 19.5833L7.08329 14.5833H8.74996V11.6667C8.74996 10.5616 8.31098 9.50175 7.52957 8.72042C6.74817 7.93898 5.68836 7.5 4.58329 7.5C3.47823 7.5 2.41842 7.93898 1.63702 8.72042C0.855609 9.50175 0.416626 10.5616 0.416626 11.6667V14.5833H2.08329L2.49996 19.5833H6.66663Z",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58329 6.24999C6.19413 6.24999 7.49996 4.94416 7.49996 3.33332C7.49996 1.72249 6.19413 0.416656 4.58329 0.416656C2.97246 0.416656 1.66663 1.72249 1.66663 3.33332C1.66663 4.94416 2.97246 6.24999 4.58329 6.24999Z",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 1.98169C2.92501 2.85121 4.14713 3.33469 5.41667 3.33336C6.12362 3.33434 6.82271 3.18492 7.4675 2.89502",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 14.5833H17.9167C18.3587 14.5833 18.7826 14.4077 19.0952 14.0952C19.4078 13.7826 19.5834 13.3587 19.5834 12.9167V2.08332C19.5834 1.6413 19.4078 1.21737 19.0952 0.904815C18.7826 0.592252 18.3587 0.416656 17.9167 0.416656H8.33337",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6724 8.12501C14.5574 8.12501 14.4641 8.03174 14.4641 7.91668C14.4641 7.80162 14.5574 7.70834 14.6724 7.70834",
    stroke: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6725 8.12501C14.7876 8.12501 14.8808 8.03174 14.8808 7.91668C14.8808 7.80162 14.7876 7.70834 14.6725 7.70834",
    stroke: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6724 11.4583C14.5574 11.4583 14.4641 11.3651 14.4641 11.25C14.4641 11.1349 14.5574 11.0417 14.6724 11.0417",
    stroke: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6725 11.4583C14.7876 11.4583 14.8808 11.3651 14.8808 11.25C14.8808 11.1349 14.7876 11.0417 14.6725 11.0417",
    stroke: "#737373"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHlTeachers);
export default __webpack_public_path__ + "static/media/HL_Teachers.48aebd449e34558f5598cf587a3e2f52.svg";
export { ForwardRef as ReactComponent };